export default {
  lang: {
    confirm: {
      title: '¿Confirma que desea eliminar? No se recuperará después de la eliminación',
      okText: 'Eliminar',
      cancelText: 'Cancelación',
    },
  },
};
